import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRootState } from "../../app/store";

const LS_KEYS = {
  showOnlyLockedRooms: "ceiling.showOnlyLockedRooms",
} as const;

const loadBoolean = (key: string, fallback: boolean): boolean => {
  const value = localStorage.getItem(key);
  if (value == null) return fallback;
  return value === "true";
};

export interface ICeilingSliceState {
  showOnlyLockedRooms: boolean;
  selectedSimilarRoomWithDevicesNumber: string | null;
  selectedSimilarRoomWithIfcDesignNumber: string | null;
}

const initialState: ICeilingSliceState = {
  showOnlyLockedRooms: loadBoolean(LS_KEYS.showOnlyLockedRooms, false),
  selectedSimilarRoomWithDevicesNumber: null,
  selectedSimilarRoomWithIfcDesignNumber: null,
};

export const ceilingSlice = createSlice({
  name: "ceiling",
  initialState,
  reducers: {
    setCeilingShowOnlyLockedRooms: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem(LS_KEYS.showOnlyLockedRooms, String(action.payload));
      state.showOnlyLockedRooms = action.payload;
    },
    setCeilingSelectedSimilarRoomWithDevicesNumber: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedSimilarRoomWithDevicesNumber = action.payload;
    },
    setCeilingSelectedSimilarRoomWithIfcDesignNumber: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedSimilarRoomWithIfcDesignNumber = action.payload;
    },
  },
});

export const {
  setCeilingSelectedSimilarRoomWithDevicesNumber,
  setCeilingSelectedSimilarRoomWithIfcDesignNumber,
  setCeilingShowOnlyLockedRooms,
} = ceilingSlice.actions;

export const selectCeilingShowOnlyLockedRooms = (state: IRootState): boolean =>
  state.ceiling.showOnlyLockedRooms;

export const selectCeilingSelectedSimilarRoomWithDevicesNumber = (
  state: IRootState
): string | null => state.ceiling.selectedSimilarRoomWithDevicesNumber;

export const selectCeilingSelectedSimilarRoomWithIfcDesignNumber = (
  state: IRootState
): string | null => state.ceiling.selectedSimilarRoomWithIfcDesignNumber;
